import React, { useEffect, useState } from "react";
import { UserProvider, useUser } from "./UserContext";
import Home from "./Home";
import Header from "./Header";
import CartModal from "./CartModal";
import "./App.css";
import LoginModal from "./LoginModal";
import RegisterModal from "./RegisterModal";
import MiniPlayer from "./MiniPlayer";
import { Route, Routes, BrowserRouter, useLocation } from "react-router-dom";
import Footer from "./Footer";
import Services from "./Services";
import LearnMusic from "./LearnMusic";
import Releases from "./Releases";
import SeparateBeat from "./SeparateBeat";
import SellBeat from "./SellBeat";
import SellTutorials from "./SellTutorials";
import PrivacyPolicy from "./PrivacyPolicy";
import ContactUs from "./ContactUs";
import Refund from "./Refund";
import TermsAndConditions from "./TermsAndConditions";
import Checkout from "./Checkout";
import Navigation from "./Navigation";
import BeatMaker from "./BeatMaker";
import Redirect from "./Redirect";
import PaymentFail from "./PaymentFail";
import Purchased from "./Purchased";
import ProfileSettings from "./ProfileSettings";
import Aconv from "./Aconv";
import YourProducts from "./YourProducts";
import Athumb from "./Athumb";
import SellFashion from "./SellFashion";
import Fashion from "./Fashion";
import Chess from "./chess/Chess";
import Room from "./room/Room";
import PrivateRoom from "./room/PrivateRoom";
import Carousal from "./Carousal";
import SoldProducts from "./SoldProducts";
import Offers from "./Offers";
import SeparateLearnMusic from "./SeparateLearnMusic";
import Notify from "./Notify";
import Studio from "./Studio";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TermsModal from "./TermsModal";
import SupportChat from "./SupportChat";
import SupportAdmin from "./SupportAdmin";
import Ai from "./Ai";
import AiMusic from "./AiMusic";
import AdminAiUpload from "./AdminAiUpload";
import Plans from "./Plans";
import SubscriptionSuccess from "./SubscriptionSuccess";
function AppWrapper() {
  const [isHeaderScrolled, setHeaderScrolled] = useState(false);
  const [showNavigation, setShowNavigation] = useState(false);
  const { currentTrack, isPlaying, togglePlay, user, termsAccepted } =
    useUser();
  const [isCartModalOpen, setCartModalOpen] = useState(false);
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setRegisterModalOpen] = useState(false);
  const location = useLocation(); // This hook gives you access to the location object

  const [showTermsModal, setShowTermsModal] = useState(false);
  const toggleCartModal = () => setCartModalOpen(!isCartModalOpen);
  const toggleLoginModal = () => {
    setRegisterModalOpen(false);
    setLoginModalOpen(!isLoginModalOpen);
  };
  const toggleRegisterModal = () => {
    setLoginModalOpen(false);
    setRegisterModalOpen(!isRegisterModalOpen);
  };
  useEffect(() => {
    const handleUnhandledRejection = (event) => {
      const reason = event.reason;

      if (
        reason &&
        (reason.name === "AbortError" ||
          String(reason.message || "").includes(
            "signal is aborted without reason",
          ))
      ) {
        event.preventDefault();
      }
    };

    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection,
      );
    };
  }, []);
  useEffect(() => {
    let timer;

    if (user && !termsAccepted) {
      timer = setTimeout(() => {
        setShowTermsModal(true);
      }, 10000);
    } else {
      setShowTermsModal(false); // ✅ Close modal if terms now accepted
    }

    return () => clearTimeout(timer);
  }, [user, termsAccepted]);

  useEffect(() => {
    const handleScroll = () => {
      const isBeatMakerPage = location.pathname === "/beatmaker";

      if (window.scrollY > 50 && isBeatMakerPage) {
        setHeaderScrolled(true); // Set the state when scrolled down
      } else {
        setHeaderScrolled(false); // Reset the state when at the top
      }
      if (showNavigation) {
        setShowNavigation(false); // Close navigation on scroll
      }
    };

    const handleOutsideClick = (event) => {
      if (!event.target.closest(".menu-icon1") && showNavigation) {
        setShowNavigation(false); // Close navigation on mouseup outside
      }
    };

    document.addEventListener("mouseup", handleOutsideClick);
    document.addEventListener("scroll", handleScroll, true);

    return () => {
      document.removeEventListener("mouseup", handleOutsideClick);
      document.removeEventListener("scroll", handleScroll, true);
    };
  }, [showNavigation, location]);

  const toggleNavigation = (event) => {
    if (event.target.closest(".menu-icon1")) {
      setShowNavigation((prevState) => !prevState);
    }
  };
  function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
      // Only scroll to top on full page route change
      if (
        !pathname.includes("/beats/") &&
        !pathname.includes("/learnmusic/") &&
        !pathname.includes("/")
      ) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, [pathname]);

    return null;
  }

  return (
    <div className={`App ${isHeaderScrolled ? "scrolled" : ""}`}>
      <div className="header-above">
        <Header
          onOpenCart={toggleCartModal}
          onOpenLogin={toggleLoginModal}
          toggleNavigation={toggleNavigation}
        />
        <Navigation
          show={showNavigation}
          onClose={() => setShowNavigation(false)}
        />
      </div>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <Home
              isCartOpen={isCartModalOpen}
              isLoginOpen={isLoginModalOpen}
              onCartClose={toggleCartModal}
              onLoginClose={toggleLoginModal}
            />
          }
        />
        <Route
          path="/beats"
          element={
            <Home
              isCartOpen={isCartModalOpen}
              isLoginOpen={isLoginModalOpen}
              onCartClose={toggleCartModal}
              onLoginClose={toggleLoginModal}
            />
          }
        />
        <Route path="/beats/:beatName" element={<SeparateBeat />} />
        <Route path="/services" element={<Services />} />
        <Route path="/beatmaker" element={<BeatMaker />} />
        <Route path="/notify" element={<Notify />} />
        <Route path="/learn" element={<LearnMusic />} />
        <Route path="/ai" element={<Ai />} />{" "}
        <Route path="/ai-music" element={<AiMusic />} />
        <Route path="/learn/:tutorialTitle" element={<SeparateLearnMusic />} />
        <Route path="/releases" element={<Releases />} />
        <Route path="/sell-beat" element={<SellBeat />} />
        <Route path="/sell-tutorials" element={<SellTutorials />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/redirect" element={<Redirect />} />
        <Route path="/paymentfail" element={<PaymentFail />} />
        <Route path="/purchased" element={<Purchased />} />
        <Route path="/aconv" element={<Aconv />} />
        <Route path="/chess" element={<Chess />} />
        <Route path="/room" element={<Room />} />
        <Route path="/athumb" element={<Athumb />} />
        <Route path="/profile-settings" element={<ProfileSettings />} />
        <Route path="/your-products" element={<YourProducts />} />{" "}
        <Route path="/your-products/sold" element={<SoldProducts />} />
        <Route path="/sell-fashion" element={<SellFashion />} />
        <Route path="/fashion" element={<Fashion />} />
        <Route path="/PrivateRoom" element={<PrivateRoom />} />
        <Route path="/offers" element={<Offers />} />
        <Route path="/studio" element={<Studio />} />
        <Route path="/fashion/:brandName" element={<Fashion />} />
        <Route path="/admin" element={<SupportAdmin />} />
        <Route path="/admin/aiupload" element={<AdminAiUpload />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/pricing" element={<Plans />} />
        <Route path="/subscription-success" element={<SubscriptionSuccess />} />
      </Routes>
      <SupportChat />
      {currentTrack && (
        <MiniPlayer
          currentTrack={currentTrack}
          onTogglePlay={togglePlay}
          playing={isPlaying}
        />
      )}

      <CartModal isCartOpen={isCartModalOpen} onCartClose={toggleCartModal} />
      <LoginModal
        isLoginOpen={isLoginModalOpen}
        onLoginClose={toggleLoginModal}
        toggleRegisterModal={toggleRegisterModal}
      />
      <RegisterModal
        isRegisterOpen={isRegisterModalOpen}
        onRegisterClose={toggleRegisterModal}
        toggleLoginModal={toggleLoginModal}
      />
      <ToastContainer position="top-center" autoClose={3000} />
      {showTermsModal && <TermsModal />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <UserProvider>
        <AppWrapper />
        <Footer />
      </UserProvider>
    </BrowserRouter>
  );
}

export default App;
